import React from "react";
import { createRoot } from "react-dom/client";
import { Provider, connect } from "react-redux";
import {ReactRoot} from "./ReactRoot"
import store, { mapStateToProps, mapDispatchToProps } from "./util/store"
import { connectToReduxPersistence } from "./util/firestoreModel"; 
import { updateFromFirebase } from "./util/store"; 
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./util/firebaseAuth"; 

const root = createRoot(document.getElementById("root"));

const ConnectedApp = connect(mapStateToProps, mapDispatchToProps)(ReactRoot);

onAuthStateChanged(auth, async (user) => {
  if (user) {
    console.log("User is logged in:", user.uid);
    await connectToReduxPersistence(store, updateFromFirebase, user.uid);
   

    console.log("Current Redux store state:", store.getState());
  } else {
    console.log("User not logged in");
  }

  root.render(
    <Provider store={store}>
      <ConnectedApp />
    </Provider>
  );
});